module.exports = __webpack_public_path__ + "static/home-services-image-2-450da45943b993986003e692c1b28105.svg";